import { render } from "./profitSummary.vue?vue&type=template&id=5cd60ef7"
import script from "./profitSummary.vue?vue&type=script&lang=js"
export * from "./profitSummary.vue?vue&type=script&lang=js"

import "./profitSummary.vue?vue&type=style&index=0&id=5cd60ef7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__